import { identifyVisitor, notifyEngageXLead } from "../../lib/engageXClient";

// Runs in the visitor's browser: it reads the UTM values from localStorage.
// The lead itself is created by the site's server (/api/bitrix/lead), so the
// Bitrix webhook, whose token gives access to the whole CRM, never reaches
// the page. The server also sets what a visitor must not choose: the lead's
// title, status, owner and visitor id (lib/bitrixLead).

export const bitrixLeadAction = async (data, queryParams, sourceId) => {
  // Every website form calls this, so it is the one place that knows who the
  // visitor is. Runs before the CRM call so the profile is named even if the
  // lead fails to save.
  identifyVisitor({
    name: data?.name,
    email: data?.email,
    phone: data?.phone,
    company: data?.company_name,
  });

   // Get params from request
  const click_id = localStorage.getItem("click_id") || "";
  const utm_source = localStorage.getItem("utm_source") || "";
  const utm_medium = localStorage.getItem("utm_medium") || "";
  const utm_campaign = localStorage.getItem("utm_campaign") || "";
  const campaign_id = localStorage.getItem("campaign_id") || "";
  const utm_term = localStorage.getItem("utm_term") || "";
  const utm_content = localStorage.getItem("utm_content") || "";
  const adgroup_id = localStorage.getItem("adgroup_id") || "";
  const ad_id = localStorage.getItem("ad_id") || "";
  const keyword = localStorage.getItem("keyword") || "";
  const matchtype = localStorage.getItem("matchtype") || "";
  const device = localStorage.getItem("device") || "";
  const network = localStorage.getItem("network") || "";
  const enquiryTypeField =
    typeof data?.isCorporate === "boolean"
      ? { UF_CRM_1615455471368: data.isCorporate ? 1789 : 1787 }
      : {};
  const extraBitrixFields =
    data?.bitrixFields && typeof data.bitrixFields === "object"
      ? data.bitrixFields
      : {};

  const fields = {
    UF_CRM_1695804853691: utm_source || "",
    UF_CRM_1695804234321: campaign_id || utm_campaign || "",
    UF_CRM_1695804262987: utm_medium || "",
    UF_CRM_1695804290715: utm_term || "",
    UTM_SOURCE: utm_source || "",
    UTM_CAMPAIGN: utm_campaign || "",
    UTM_MEDIUM: utm_medium || "",
    UTM_TERM: utm_term || "",
    UTM_CONTENT: utm_content || "",
    UF_CRM_1739521212650: click_id || "",
    UF_CRM_1781023469859: adgroup_id || "",
    UF_CRM_1785838050151: ad_id || "",
    UF_CRM_1778509867532: keyword || "",
    UF_CRM_1785838080420: matchtype || "",
    UF_CRM_1785838108245: device || "",
    UF_CRM_1785838124651: network || "",
    UF_CRM_1744613826052: data?.preferred_time_callback || "",
    UF_CRM_1744613784579: data?.start_date || "",
    COMPANY_TITLE: data?.company_name || "",
    UF_CRM_1684372737584: data?.pax || "",
    NAME: data?.name,
    country_name: "",
    course_id: data?.course?.id || 2304,
    PHONE: [
      {
        VALUE: data?.phone,
        VALUE_TYPE: "WORK",
      },
    ],
    EMAIL: [
      {
        VALUE: data?.email,
        VALUE_TYPE: "WORK",
      },
    ],
    COMMENTS: data?.message,
    SOURCE_ID: sourceId,
    UF_CRM_1584949782: "sw",
    UF_CRM_1584950014: "",
    ...enquiryTypeField,
    ...extraBitrixFields,
  };
  const product = {
    productId: data?.course?.productId || 4648,
    price: data?.course?.price || data?.course?.discountPrice || 0,
  };

  try {
    const leadReq = await fetch("/api/bitrix/lead", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fields, product }),
    });

    const leadRes = await leadReq.json().catch(() => ({}));

    const lead_id = leadRes?.leadId;
    if (!lead_id) console.error("Bitrix lead was not created", leadReq.status);
    if (lead_id) {
      notifyEngageXLead({
        system: "bitrix",
        leadId: lead_id,
        email: data?.email,
        phone: data?.phone,
      });

      return { ...(leadRes.rows || {}), leadId: lead_id };
    }
  } catch (error) {
    console.error(error);
  }
};
